import { Typography, useTheme, Box } from "@mui/material";
import FlexBetween from "../../components/FlexBetween";
import WidgetWrapper from "../../components/WidgetWrapper";

const AdvertWidget = () => {
  const { palette } = useTheme();
  const dark = palette.neutral.dark;
  const main = palette.neutral.main;
  const medium = palette.neutral.medium;

  return (
    <WidgetWrapper>
      <FlexBetween>
        <Typography color={dark} variant="h5" fontWeight="500">
          Sponsored
        </Typography>
      </FlexBetween>
      <Box
        component="a"
        href="https://refine-web.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ textDecoration: "none", display: "block" }}
      >
        <img
          width="100%"
          height="auto"
          alt="advert"
          src="../assets/refine.png"
          style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
        />
        <FlexBetween>
          <Typography color={main}>Space Articles</Typography>
          <Typography color={medium}>refine-web.vercel.app</Typography>
        </FlexBetween>
        <Typography color={medium} m="0.5rem 0">
          Explore the mysteries of the universe. Read our latest space articles and discover the beauty of the cosmos.
        </Typography>
      </Box>
    </WidgetWrapper>
  );
};

export default AdvertWidget;
